import { Tooltip } from "@prismicio/editor-ui"
import { Suspense, useCallback } from "react"

import { useMyRole } from "../services/role"

export function SuperUserReminder() {
  return (
    <Suspense>
      <SuperUserReminderContent />
    </Suspense>
  )
}

function SuperUserReminderContent() {
  const repositoryRole = useMyRole({})
  if (repositoryRole === "SuperUser") return <SuperUserRedDot />
  return null
}

function SuperUserRedDot() {
  const setRingRef = useCallback((element: HTMLElement | null) => {
    if (!element) return

    element.animate(
      [
        { transform: "scale(0.1, 0.1)", opacity: 0 },
        { opacity: 1 },
        { transform: "scale(1.2, 1.2)", opacity: 0 },
      ],
      { duration: 1_000, iterations: Infinity },
    )
  }, [])

  return (
    <Tooltip title="You are a super user" content="Be careful! 💣">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          zIndex: 99_999,
          top: 8,
          left: 32,
        }}
      >
        <div
          style={{
            width: 16,
            height: 16,
            backgroundColor: "#CA3214",
            borderRadius: "50%",
          }}
        />
        <div
          ref={setRingRef}
          style={{
            position: "absolute",
            width: 26,
            height: 26,
            borderRadius: 26,
            border: "2px solid #CA3214",
            opacity: 1,
          }}
        />
      </div>
    </Tooltip>
  )
}
